import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Fuse from 'fuse.js';
import parseMax from 'libphonenumber-js/max';
import { FixedSizeList } from 'react-window';
import { GlobalContext } from '../../GlobalState';
import { Box, Button, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, Stepper, Step, StepLabel, ListItem, ListItemButton, ListItemIcon, ListItemText,
Checkbox, Tooltip, IconButton, InputBase, Chip } from '@mui/material';
import { Campaign as CampaignIcon, Send as SendIcon, Approval as ApprovalIcon, Check as CheckIcon, Clear as ClearIcon,
  Person as ActiveDriverIcon, PersonOff as NoActiveDriverIcon } from '@mui/icons-material';

import { delayPromise } from '../../utils';

// const getWindowSize = () => {
//   const {innerWidth, innerHeight} = window;
//   return {innerWidth, innerHeight};
// };
const getModalSizeCalc = () => {
  const {innerWidth, innerHeight} = window;
  const is_mobile = innerWidth <= 700 || innerHeight <= 700;
  const height_header = 120;
  const height_filter = 58;
  const height_actions = 70;
  const height_content = Math.max(innerHeight - height_header - height_actions, 210);
  const height_content_list = height_content - height_filter;
  return {
    is_mobile: is_mobile, height_content: height_content, height_content_list: height_content_list
  };
};
const listItemSX = {display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', width: '50px'};
const stepperData = [
  { id: 1, label: 'Select Drivers', stepProps: {}, labelProps: {} },
  { id: 2, label: 'Define a message', stepProps: {}, labelProps: {} },
  { id: 3, label: 'Review & Send', stepProps: {}, labelProps: {} }
];
const tpl_infoStep = {type: '', msg: ''};
const tpl_searchFilters_init = {activeDrivers: true, primaryDrivers: true, inputSearch: ''};
const tpl_searchFilters = {activeDrivers: false, primaryDrivers: false, inputSearch: ''};
const sortByFirstName = (a, b) => {
  let afn = a.firstName.toLowerCase(), bfn = b.firstName.toLowerCase();
  if (afn < bfn) return -1;
  else if (afn > bfn) return 1;
  else return 0;
};
export const CampaignModal = () => {
  const { globalState } = useContext(GlobalContext);
  const { is_mobile, height_content, height_content_list } = getModalSizeCalc();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [infoStep, setInfoStep] = useState(tpl_infoStep);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const [msgToDrivers, setMsgToDrivers] = useState('');
  const [searchFilters, setSearchFilters] = useState(tpl_searchFilters_init);
  useEffect(() => {
    try {
      let tmp_driversArray = [...driversArray].sort(sortByFirstName);
      if (searchFilters.inputSearch !== '') {
        const options = {
          includeScore: true,
          includeMatches: true,
          threshold: 0.2,
          keys: [ 'unitCode', 'firstName', 'lastName', 'phoneNumber', 'driverUnits']
        };
        const fuseInit = new Fuse(tmp_driversArray, options);
        const fuseResult = fuseInit.search(searchFilters.inputSearch);
        tmp_driversArray = fuseResult.map(res => res.item);
      }
      if (searchFilters.activeDrivers === true) tmp_driversArray = tmp_driversArray.filter(item => item.activeDriver === true);
      if (searchFilters.primaryDrivers  === true) tmp_driversArray = tmp_driversArray.filter(item => item.driverUnits_primary.length > 0);
      setFilteredDrivers(tmp_driversArray);
    }
    catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFilters]);
  const driversArray = Object.values(globalState.idxs.ch_list).filter(ch_item => ch_item.cid.startsWith('prime:') === true && ch_item.data.channel_type === 'driver' && ch_item.data.frozen === false).map(ch_item => {
    let ch_data = ch_item.data;
    let intPhoneNumber = '';
    if (ch_data.countryCode) intPhoneNumber += ch_data.countryCode;
    if (ch_data.phoneNumberRaw) intPhoneNumber += ch_data.phoneNumberRaw;
    let parsedPhoneNumber = parseMax('+' + intPhoneNumber, { defaultCountry: '', extract: false });
    if (parsedPhoneNumber && parsedPhoneNumber?.isValid() === true) intPhoneNumber = `(${parsedPhoneNumber.country}) ${parsedPhoneNumber.formatInternational()}`;
    else if (parsedPhoneNumber && parsedPhoneNumber?.isValid() === false) intPhoneNumber = `(INVALID) ${parsedPhoneNumber.formatInternational()}`;
    else intPhoneNumber = `(INVALID) ${intPhoneNumber}`;
    let parsedDriver = {
      cid: ch_item.cid,
      unitCode: ch_data.unitCode,
      firstName: ch_data.firstName,
      lastName: ch_data.lastName,
      phoneNumber: intPhoneNumber,
      validDriver: intPhoneNumber.startsWith('(INVALID)') === false,
      activeDriver: ch_data.isDriverActive === true,
      driverUnits: ch_data.unitCode ? ch_data.unitCode.split(' ') : [],
      driverUnits_primary: ch_data.unitsWithPrimaryContact || []
    }
    parsedDriver.driverUnits.sort((a, b) => {
      let adu = parsedDriver.driverUnits_primary.includes(a), bdu = parsedDriver.driverUnits_primary.includes(b);
      if (adu === true && bdu === false) return -1;
      else if (adu === false && bdu === true) return 1;
      else return 0;
    });
    return parsedDriver;
  });
  const invalidDriversArray = driversArray.filter(item => item.validDriver === false).map(item => item.cid);

  const toogleSelectedDrivers_all = () => {
    let cids_filtered = [...filteredDrivers].map(item => item.cid).filter(cid => invalidDriversArray.includes(cid) === false);
    let cids_filtered_selected = cids_filtered.filter(cid => selectedDrivers.includes(cid) === true);
    let cids_filtered_selected_not = cids_filtered.filter(cid => selectedDrivers.includes(cid) === false);
    if (cids_filtered.length === cids_filtered_selected.length) setSelectedDrivers(prev => [...prev].filter(cid => cids_filtered_selected.includes(cid) === false))
    else setSelectedDrivers(prev => [...prev, ...cids_filtered_selected_not]);
    if (infoStep.type !== '') setInfoStep(tpl_infoStep);
  };
  const toogleSelectedDrivers = (ch_cid) => (e) => {
    if (invalidDriversArray.includes(ch_cid) === true) return false;
    const currentIndex = selectedDrivers.indexOf(ch_cid);
    const newSelectedDrivers = [...selectedDrivers];
    if (currentIndex === -1) newSelectedDrivers.push(ch_cid);
    else newSelectedDrivers.splice(currentIndex, 1);
    setSelectedDrivers(newSelectedDrivers);
    if (infoStep.type !== '') setInfoStep(tpl_infoStep);
  };

  const handleSearchFilters = (e) => setSearchFilters(prev => ({...prev, [e.target.id]: e.target.id === 'inputSearch' ? e.target.value : !prev[e.target.id]}));

  const onChangeMsgToDrivers = (e) => {
    e.preventDefault();
    if (e.target.value.length === 600) setInfoStep({type: 'info', msg: 'Campaign message cannot exceed 600 length'});
    else if (infoStep.type !== '') setInfoStep(tpl_infoStep);
    setMsgToDrivers(e.target.value);
  };
  const onClickPrevStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (activeStep === 1) setSearchFilters(tpl_searchFilters_init);
    else setSearchFilters(tpl_searchFilters);
    if (infoStep.type !== '') setInfoStep(tpl_infoStep);
  };
  const onClickNextStep = async () => {
    let doNextStep = false;
    if (activeStep === 0) {
      if (selectedDrivers.length > 0) doNextStep = true;
      else setInfoStep({type: 'error', msg: 'Select at least one driver'});
    }
    if (activeStep === 1) {
      if (msgToDrivers === '') setInfoStep({type: 'error', msg: 'Message must be defined'});
      else if (msgToDrivers.length < 20) setInfoStep({type: 'error', msg: 'Message is too short'});
      else doNextStep = true;
    }
    if (activeStep === 2) doNextStep = true;
    if (activeStep === 3) {
      let campaignResult = await sendCampaign();
      if (campaignResult === true) {
        setInfoStep({type: 'info', msg: 'Campaign message was successfully sent'});
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setIsSending(false);
        return true;
      }
      else setInfoStep({type: 'error', msg: 'Campaign message could not be sent'});
    }
    if (doNextStep === true) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSearchFilters(tpl_searchFilters);
      if (infoStep.type !== '') setInfoStep(tpl_infoStep);
    }
  };
  const clickCloseModal = async (e, r) => {
    if (r === 'backdropClick' || r === 'escapeKeyDown') return false;
    setIsModalOpen(false);
    await delayPromise(250);
    setActiveStep(0);
    setSelectedDrivers([]);
    setMsgToDrivers('');
    setSearchFilters(tpl_searchFilters_init);
    setInfoStep(tpl_infoStep);
  };
  const sendCampaign = async () => {
    try {
      setIsSending(true);
      if (selectedDrivers.length === 0 || msgToDrivers.length === 0) return false;
      let axiosReq = { token: globalState.app_config.authToken, data: { channels: selectedDrivers, message: msgToDrivers } };
      const axiosRes = await axios.post(globalState.app_config.authEnv+'/send/bulk', axiosReq);
      if (axiosRes.status === 200 && axiosRes.data && axiosRes.data.result === true && axiosRes.data.numberOfSentMessages > 0) return true;
      else return false;
    } catch (err) {
      console.log('Error', err);
    }
  };
  const areFilteredChecked = filteredDrivers.length > 0 ? filteredDrivers.map(item => item.cid).filter(cid => invalidDriversArray.includes(cid) === false).filter(ch_cid => selectedDrivers.includes(ch_cid) === true).length === filteredDrivers.map(item => item.cid).filter(cid => invalidDriversArray.includes(cid) === false).length : false;
  if (driversArray.length === 0)
  return (
    <>
    <ListItem key={'startcampaing'} disablePadding sx={{ display: 'block' }}>
      <ListItemButton sx={{ minHeight: 48, justifyContent: 'center', px: 2.5 }} onClick={() => setIsModalOpen(prev => !prev)}>
        <Tooltip title={`Start Campaign`} placement='right'>
          <ListItemIcon sx={{minWidth: 0, mr: 'auto', justifyContent: 'center'}}>
            <CampaignIcon />
          </ListItemIcon>
        </Tooltip>
      </ListItemButton>
    </ListItem>
    <Dialog fullScreen={is_mobile} scroll={'paper'} fullWidth={true} maxWidth={'sm'} open={isModalOpen} onClose={clickCloseModal}>
      <DialogContent sx={{p:0, m: 0}}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', m: 0, pt: 2, height: '100%'}}>
          <Box sx={{ flex: '1 1 auto' }} />
          <Typography color='error.main' component='div' variant='h6' fontStyle='italic'>{'Driver channels couldn\'t be found'}</Typography>
          <Box sx={{ flex: '1 1 auto' }} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', flexDirection: 'row', m: 0, pb: 2, px: 2}}><Button variant='text' onClick={clickCloseModal}>{'Close'}</Button></DialogActions>
    </Dialog>
    </>
  )
  return (
    <>
    <ListItemButton sx={{ minHeight: 48, justifyContent: 'center', px: 2.5 }} onClick={() => setIsModalOpen(prev => !prev)}>
      <Tooltip title={`Start Campaign`} placement='right'>
        <ListItemIcon sx={{minWidth: 0, mr: 'auto', justifyContent: 'center'}}>
          <CampaignIcon />
        </ListItemIcon>
      </Tooltip>
    </ListItemButton>
    <Dialog fullScreen={is_mobile} scroll={'paper'} fullWidth={true} maxWidth={'lg'} open={isModalOpen} onClose={clickCloseModal}>
      <DialogTitle sx={{pt: 3}}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {stepperData.map((stepData, index) => (<Step key={stepData.id} {...stepData.stepProps}><StepLabel {...stepData.labelProps}>{stepData.label}</StepLabel></Step>))}
        </Stepper>
      </DialogTitle>
      { activeStep === 0 &&
      <DialogContent sx={{p:0, m: 0, minHeight: is_mobile === true ? height_content : 540}}>
        <Box sx={{ m: 0, p: 0, minWidth: 1200, overflowX: 'auto' }}>
          <Divider orientation='horizontal'/>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', m: 0, py: 1, px: 2}}>
            <ListItemIcon onClick={toogleSelectedDrivers_all}>
              <Tooltip title={areFilteredChecked ? 'Unselect all' : 'Select all'} placement='bottom'>
                <Checkbox checked={areFilteredChecked} disabled={filteredDrivers.length === 0} edge='start' tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': 'select-all' }}/>
              </Tooltip>
            </ListItemIcon>
            <InputBase sx={{ ml: 1, width: '160px' }} size='small' placeholder='Search Drivers' type='text' onChange={handleSearchFilters} id='inputSearch' value={searchFilters.inputSearch} multiline={false}  inputProps={{ 'aria-label': 'search drivers' }}/>
            { searchFilters.inputSearch !== '' && <IconButton size='small' type='button' aria-label='reset search' onClick={() => setSearchFilters(prev => ({...prev, inputSearch: ''}))}><ClearIcon /></IconButton>}
            <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
            <Button variant='outlined' size='small' sx={{ml:1}} startIcon={searchFilters.activeDrivers === true ? <CheckIcon /> : null} id='activeDrivers' onClick={handleSearchFilters}>{'Active'}</Button>
            <Button variant='outlined' size='small' sx={{ml:1}} startIcon={searchFilters.primaryDrivers === true ? <CheckIcon /> : null} id='primaryDrivers' onClick={handleSearchFilters}>{'Primary'}</Button>
            <Box sx={is_mobile === true ? { minWidth: 20 } : { flex: '1 1 auto', minWidth: 20 }} />
            <Typography mr={2} component='div' color='grey.500' variant='body1' fontStyle='italic'>{`${selectedDrivers.length}/${driversArray.length} drivers selected`}</Typography>
          </Box>
          <Divider orientation='horizontal'/>
          <FixedSizeList height={is_mobile === true ? height_content_list : 450} width={'100%'} itemSize={58} itemData={filteredDrivers} itemCount={filteredDrivers.length} overscanCount={4}>
            {(listProps) => {
              const { data, index, style } = listProps;
              const item = data[index];
              return (
                <>
                  <ListItem style={style} key={item.cid} component='div' disablePadding divider={true}>
                    <ListItemButton role={undefined} sx={{height: '100%'}} onClick={toogleSelectedDrivers(item.cid)} selected={selectedDrivers.indexOf(item.cid) !== -1} disabled={invalidDriversArray.includes(item.cid) === true}>
                      <ListItemIcon sx={{minWidth: '36px', width: '36px'}}>
                        <Checkbox edge='start' checked={selectedDrivers.indexOf(item.cid) !== -1} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': item.cid }}/>
                      </ListItemIcon>
                      <ListItemIcon sx={{minWidth: '36px', width: '36px'}}>
                        { item.activeDriver === true ? <ActiveDriverIcon fontSize='small' color='primary'/> : <NoActiveDriverIcon fontSize='small' color='primary'/> }
                      </ListItemIcon>
                      <ListItemText
                        id='driverUnits'
                        sx={{...listItemSX, width: '45%'}}
                        primary={item.driverUnits.sort((a, b) => {
                            if (a > b) return -1;
                            else if (b < a) return 1;
                            else return 0;
                          }).map((unit, index) => <Chip
                          key={item.cid+unit+index} label={unit} size='small' color='primary' sx={{ml: index === 0 ? 0 : 0.2}}
                          onClick={(e) => {
                            e.preventDefault();
                            setSearchFilters(prev => ({...prev, inputSearch: prev.inputSearch === unit ? '' : unit}));
                            e.stopPropagation();
                          }}
                          variant={item.driverUnits_primary.includes(unit) === true ? 'filled' : 'outlined'}
                          />)}
                        />
                      <ListItemText sx={listItemSX} primary={<Typography fontWeight={400}>{item.firstName} {item.lastName}</Typography>}/>
                      <ListItemText sx={listItemSX} primary={<Typography fontWeight={400}>{item.phoneNumber}</Typography>}/>
                    </ListItemButton>
                  </ListItem>
                </>
              );
            }}
          </FixedSizeList>
        </Box>
      </DialogContent> }
      { activeStep === 1 &&
      <DialogContent sx={{display: 'flex', flexDirection: 'column', p:0, m: 0, minHeight: is_mobile === true ? height_content : 540}}>
        <Divider orientation='horizontal' />
        <Box sx={{ flex: '1 1 auto' }} />
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', m: 0, pb: 0, pt: 2, px: 4, height: '100%'}}>
          <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', m: 0, p: 0, height: '100%'}}>
            <Typography paragraph={false} fontStyle='italic'>
              {'Hello, this is Force Trans Inc.'}<br/>{'Please update your availability and current location.'}<br/>{'Thank you and have a good day!'}
            </Typography>
            <Button variant='text' sx={{mr: 'auto'}} onClick={() => setMsgToDrivers('Hello, this is Force Trans Inc.\nPlease update your availability and current location.\nThank you and have a good day!')}>{'Use template'}</Button>
          </Box>
          <TextField onChange={onChangeMsgToDrivers} value={msgToDrivers} inputProps={{ maxLength: 600 }} component='div' fullWidth label='Message' placeholder='Type here your message' multiline minRows={18} maxRows={18} />
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />
      </DialogContent> }
      { (activeStep === 2 || activeStep === 3 || activeStep === 4) &&
      <DialogContent sx={{p:0, m: 0, minHeight: is_mobile === true ? height_content : 540}}>
        <Box sx={{ m: 0, p: 0, minWidth: 1200, overflowX: 'auto' }}>
          <Divider orientation='horizontal' />
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', m: 0, pb: 2, pt: 2, px: 4, height: '130px', overflowY: 'auto', whiteSpace: 'pre-line'}}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Typography paragraph={false} fontStyle='italic' sx={{width: '50%'}}>{msgToDrivers}</Typography>
            <Box sx={{ flex: '1 1 auto' }} />
          </Box>
          <Divider orientation='horizontal'/>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', m: 0, py: 1, px: 2}}>
            <ListItemIcon><Checkbox edge='start' checked={areFilteredChecked} disabled={true} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': 'select-all' }}/></ListItemIcon>
            <InputBase sx={{ ml: 1, width: '160px' }} size='small' placeholder='Search Drivers' type='text' onChange={handleSearchFilters} id='inputSearch' value={searchFilters.inputSearch} multiline={false}  inputProps={{ 'aria-label': 'search drivers' }}/>
            { searchFilters.inputSearch !== '' && <IconButton size='small' type='button' aria-label='reset search' onClick={() => setSearchFilters(prev => ({...prev, inputSearch: ''}))}><ClearIcon /></IconButton>}
            <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
            <Button variant='outlined' size='small' sx={{ml:1}} startIcon={searchFilters.activeDrivers === true ? <CheckIcon /> : null} id='activeDrivers' onClick={handleSearchFilters}>{'Active'}</Button>
            <Button variant='outlined' size='small' sx={{ml:1}} startIcon={searchFilters.primaryDrivers === true ? <CheckIcon /> : null} id='primaryDrivers' onClick={handleSearchFilters}>{'Primary'}</Button>
            <Box sx={{ flex: '1 1 auto' }} />
            <Typography mr={2} component='div' color='grey.500' variant='body1' fontStyle='italic'>{`${selectedDrivers.length}/${driversArray.length} drivers selected`}</Typography>
          </Box>
          <Divider orientation='horizontal'/>
          <FixedSizeList height={is_mobile === true ? height_content_list : 320} width={'100%'} itemSize={58} itemData={filteredDrivers} itemCount={filteredDrivers.length} overscanCount={4}>
            {(listProps) => {
              const { data, index, style } = listProps;
              const item = data[index];
              return (
                <>
                  <ListItem style={style} key={item.cid} component='div' disablePadding divider={true}>
                    <ListItemButton role={undefined} sx={{height: '100%'}} selected={selectedDrivers.indexOf(item.cid) !== -1} disabled={true}>
                      <ListItemIcon sx={{minWidth: '36px', width: '36px'}}>
                        <Checkbox edge='start' disabled={true} checked={selectedDrivers.indexOf(item.cid) !== -1} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': item.cid }}/>
                      </ListItemIcon>
                      <ListItemIcon sx={{minWidth: '36px', width: '36px'}}>
                        { item.activeDriver === true ? <ActiveDriverIcon fontSize='small' color='primary'/> : <NoActiveDriverIcon fontSize='small' color='primary'/> }
                      </ListItemIcon>
                      <ListItemText
                        id='driverUnits'
                        sx={{...listItemSX, width: '45%'}}
                        primary={item.driverUnits.sort((a, b) => {
                            if (a > b) return -1;
                            else if (b < a) return 1;
                            else return 0;
                          }).map((unit, index) => <Chip
                          key={item.cid+unit+index} label={unit} size='small' color='primary' sx={{ml: index === 0 ? 0 : 0.2}}
                          onClick={(e) => {
                            e.preventDefault();
                            setSearchFilters(prev => ({...prev, inputSearch: prev.inputSearch === unit ? '' : unit}));
                            e.stopPropagation();
                          }}
                          variant={item.driverUnits_primary.includes(unit) === true ? 'filled' : 'outlined'}
                          />)}
                        />
                      <ListItemText sx={listItemSX} primary={<Typography fontWeight={400}>{item.firstName} {item.lastName}</Typography>}/>
                      <ListItemText sx={listItemSX} primary={<Typography fontWeight={400}>{item.phoneNumber}</Typography>}/>
                    </ListItemButton>
                  </ListItem>
                </>
              );
            }}
          </FixedSizeList>
        </Box>
      </DialogContent> }
      <DialogActions sx={{ display: 'flex', flexDirection: 'row', m: 0, py: 2, px: 2}}>
        { activeStep < 3 && <Button variant='text' disabled={activeStep === 0} onClick={onClickPrevStep} sx={{ mr: 1 }}>{'Back'}</Button> }
        <Box sx={{ flex: '1 1 auto' }} />
        {infoStep.type !== '' && <Typography mr={2} color={infoStep.type+'.main'} component='div' variant='body1' fontStyle='italic'>{infoStep.msg}</Typography>}
        { activeStep <= 1 && <Button variant='outlined' color={infoStep.type === 'error' ? 'error' : 'primary'} onClick={onClickNextStep}>{'Next'}</Button>}
        { activeStep === 2 && <Button variant='outlined' endIcon={<ApprovalIcon/>} color={infoStep.type === 'error' ? 'error' : 'warning'} onClick={onClickNextStep}>{'Reviewed'}</Button>}
        { activeStep === 3 && isSending === false && <Button variant='outlined' endIcon={<SendIcon/>} color={infoStep.type === 'error' ? 'error' : 'primary'} onClick={onClickNextStep}>{'Send'}</Button>}
        { activeStep === 3 && isSending === true && <Button variant='outlined' endIcon={<SendIcon/>} disabled>{'Send'}</Button>}
        <Button variant='text' onClick={clickCloseModal}>{'Close'}</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};